import type { CastProfile } from './castProfiles.ts'
import type { CastProfileTimeline } from './castProfileTimelines.ts'

// Original Journey90 editorial profiles researched October 1, 2026.
// Historical season events do not certify present relationship/legal status.
// Supporting introductions are distinguished from a person's own romance.
// No exact episode appearances or unverified partner-page IDs are inferred.
export const researchedProfilesC: CastProfile[] = [
  {
    "personId": "p-tim-malcolm",
    "headline": "A Colombia trip, an ex who stayed a best friend, and a dating life with a very active commentary booth.",
    "bio": [
      "Tim entered Before the 90 Days to meet Colombian online match Jeniffer. Their romantic spark struggled in person, while his closeness with ex-fiancée Veronica became a storyline of its own. Even a promise ring arrived with a surprisingly full résumé.",
      "He later dated Luisa on The Single Life and met Mei at the Hunt for Love retreat. Having Jeniffer at that same resort gave his fresh start a rather ambitious guest list."
    ],
    "originStory": "After eight months on a Colombian dating website, Tim traveled to meet Jeniffer on Before the 90 Days Season 3.",
    "journeys": [
      {
        "label": "Where it started: Tim & Jeniffer",
        "partnerName": "Jeniffer Tarazona",
        "relationshipId": "ARC-5E9901D5F3A9",
        "era": "Before the 90 Days S3",
        "summary": "Their Colombia visit exposed different expectations of affection; TLC subsequently confirmed their split."
      },
      {
        "label": "Earlier relationship, lasting friendship",
        "partnerName": "Veronica Rodriguez",
        "era": "Before the franchise and after",
        "summary": "Tim and Veronica’s engagement ended, but they remained close and continued supporting her daughter."
      },
      {
        "label": "Later dating chapters",
        "partnerName": "Luisa and Mei",
        "era": "The Single Life S4 · Hunt for Love S1",
        "summary": "Tim dated Luisa before exploring a short-lived retreat connection with Mei."
      }
    ],
    "sources": [
      {
        "label": "TLC: Jeniffer and Tim’s first chapter",
        "url": "https://www.tlc.com/inside-tlc/jeniffer-journey-so-far"
      },
      {
        "label": "TheTVDB: The Single Life season 4 story descriptions",
        "url": "https://thetvdb.com/series/90-day-the-single-life/allseasons/official"
      },
      {
        "label": "ET: Veronica and Jamal’s exclusive relationship",
        "url": "https://www.etonline.com/90-day-the-single-life-veronica-and-jamal-commit-to-being-exclusive-exclusive-217176"
      },
      {
        "label": "TLC: Hunt for Love’s returning singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-meet-the-90-day-singles"
      },
      {
        "label": "TV Insider: Hunt for Love season 1 couples",
        "url": "https://www.tvinsider.com/swooon/gallery/90-day-hunt-for-love-season-1-couples-still-together-relationship-updates/"
      }
    ]
  },
  {
    "personId": "p-veronica-rodriguez",
    "headline": "A best friend with front-row seats who eventually took the dating spotlight herself.",
    "bio": [
      "Veronica first entered viewers’ orbit as Tim’s ex-fiancée and close friend during his Jeniffer romance. Their bond survived the engagement’s end, making every new date a potential introduction to the world’s most attentive unofficial screening committee.",
      "On The Single Life, the mother explored dating on her own terms, then a long-distance relationship with Kim’s son Jamal. Their differing communication needs and Tim’s continued presence proved difficult to balance."
    ],
    "originStory": "Veronica’s franchise introduction came through her friendship with ex-fiancé Tim, rather than a K-1 relationship of her own. The Single Life Season 3 made her dating life the main story.",
    "journeys": [
      {
        "label": "The connection that introduced her",
        "partnerName": "Tim Malcolm",
        "era": "Before the 90 Days S3 and after",
        "summary": "Their former engagement became a lasting friendship rather than an ongoing televised couple romance."
      },
      {
        "label": "A later franchise crossover",
        "partnerName": "Jamal Menzies",
        "relationshipId": "ARC-5AFE8D244E96",
        "era": "The Single Life S4",
        "summary": "A casual connection became exclusive long-distance dating; both confirmed its end at the tell-all."
      }
    ],
    "sources": [
      {
        "label": "TLC: Jeniffer and Tim’s first chapter",
        "url": "https://www.tlc.com/inside-tlc/jeniffer-journey-so-far"
      },
      {
        "label": "Us Weekly: TLC’s Single Life season 3 cast announcement",
        "url": "https://www.usmagazine.com/entertainment/pictures/90-day-the-single-life-season-3-meet-the-cast/"
      },
      {
        "label": "ET: Veronica and Jamal’s exclusive relationship",
        "url": "https://www.etonline.com/90-day-the-single-life-veronica-and-jamal-commit-to-being-exclusive-exclusive-217176"
      },
      {
        "label": "ET: Veronica and Jamal’s tell-all breakup",
        "url": "https://www.etonline.com/90-day-the-single-life-tell-all-veronica-reveals-jamal-dumped-her-with-a-peace-sign-emoji-221582"
      }
    ]
  },
  {
    "personId": "p-jamal-menzies",
    "headline": "Kim’s son went from relationship commentator to a headline in the franchise dating crossover.",
    "bio": [
      "Jamal became familiar to viewers as Kim’s son, weighing in on her relationship with Usman. His own romantic turn arrived when he and Veronica disclosed a casual connection that later became exclusive.",
      "Their Charlotte–San Diego relationship made texting habits surprisingly consequential. The Single Life followed the communication clashes and a difficult dynamic with Tim before the couple confirmed their breakup."
    ],
    "originStory": "Jamal entered the franchise through his mother Kim’s Usman storyline; his own featured romance was with Veronica on The Single Life Season 4.",
    "journeys": [
      {
        "label": "His own televised relationship",
        "partnerName": "Veronica Rodriguez",
        "relationshipId": "ARC-5AFE8D244E96",
        "era": "The Single Life S4",
        "summary": "They moved from casual dating to exclusivity before confirming their breakup at the season’s tell-all."
      },
      {
        "label": "The next chapter — announced",
        "era": "Hunt for Love S2",
        "summary": "TLC has announced a Puerto Rico return beginning October 5, 2026. No new partner or aired storyline is claimed."
      }
    ],
    "sources": [
      {
        "label": "ET: Veronica and Jamal’s exclusive relationship",
        "url": "https://www.etonline.com/90-day-the-single-life-veronica-and-jamal-commit-to-being-exclusive-exclusive-217176"
      },
      {
        "label": "ET: Veronica and Jamal’s tell-all breakup",
        "url": "https://www.etonline.com/90-day-the-single-life-tell-all-veronica-reveals-jamal-dumped-her-with-a-peace-sign-emoji-221582"
      },
      {
        "label": "TLC: Hunt for Love season 2 singles (announced)",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-season-2-singles-bios-photos"
      }
    ]
  },
  {
    "personId": "p-john-mcmanus",
    "headline": "Patrick’s outspoken brother graduated from the sidelines to his own Texas love story.",
    "bio": [
      "John was introduced through brother Patrick’s relationship with Thaís. Meghan later contacted him by direct message, giving the familiar family commentator a romance of his own.",
      "The Single Life followed his move to Texas and adjustment to life with Meghan and her daughter. TLC reported that they welcomed another daughter, Rowan, in January 2026—an especially concrete addition to the family group chat."
    ],
    "originStory": "John first appeared alongside Patrick and Thaís; Meghan’s message later led to the relationship featured on The Single Life Season 4.",
    "journeys": [
      {
        "label": "Where his own romance started",
        "partnerName": "Meghan Brown",
        "relationshipId": "ARC-F4456ED9F934",
        "era": "The Single Life S4 and after",
        "summary": "A direct message became a Texas move and a family chapter; TLC confirmed their daughter Rowan’s birth in 2026."
      }
    ],
    "sources": [
      {
        "label": "ET: John and Meghan’s commitment conversation",
        "url": "https://www.etonline.com/90-day-the-single-life-tell-all-john-appears-to-propose-to-meghan-as-patrick-exposes-their-issues"
      },
      {
        "label": "TLC: John and Meghan welcome Rowan",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/john-meghan-new-baby-daughter-photos"
      }
    ]
  },
  {
    "personId": "p-meghan-brown-john-mcmanus-arc",
    "headline": "One direct message turned into a Texas move and some very serious family conversations.",
    "bio": [
      "Meghan reached out to John after seeing him in the franchise, and their connection became a featured Single Life romance. As a mother, she wanted commitment that worked for everyday family life.",
      "The season tested their expectations about children and settling down, with Patrick offering plenty of input—family commentary was definitely not in short supply. TLC later confirmed that Meghan and John welcomed daughter Rowan in January 2026."
    ],
    "originStory": "Meghan’s direct message to John sparked the relationship followed on The Single Life Season 4, including his move to Texas.",
    "journeys": [
      {
        "label": "Where it started: Meghan & John",
        "partnerName": "John McManus",
        "relationshipId": "ARC-F4456ED9F934",
        "era": "The Single Life S4 and after",
        "summary": "Their online introduction grew into living together and a family chapter that included Rowan’s 2026 birth."
      }
    ],
    "sources": [
      {
        "label": "ET: John and Meghan’s commitment conversation",
        "url": "https://www.etonline.com/90-day-the-single-life-tell-all-john-appears-to-propose-to-meghan-as-patrick-exposes-their-issues"
      },
      {
        "label": "TLC: John and Meghan welcome Rowan",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/john-meghan-new-baby-daughter-photos"
      }
    ]
  },
  {
    "personId": "p-debbie-johnson",
    "headline": "Colt’s mother found a dating chapter—and an international move—of her own.",
    "bio": [
      "Debbie became a franchise fixture through son Colt’s relationships before taking the lead on The Single Life. Her return to dating in Season 2 coincided with Colt and Vanessa seeking more space as newlyweds.",
      "Season 3 brought Tony and a move to Canada into the picture. Debbie’s story turned from overseeing somebody else’s romance to packing for her own, although family negotiations still managed to fit in the suitcase."
    ],
    "originStory": "Debbie first appeared as Colt’s mother; The Single Life Season 2 shifted the spotlight to her own search for a partner.",
    "journeys": [
      {
        "label": "A romance of her own",
        "partnerName": "Tony",
        "era": "The Single Life S3",
        "summary": "Debbie developed a relationship with Tony and decided to move to Vancouver to live with him; a present-day legal or romantic status has not been independently checked."
      }
    ],
    "sources": [
      {
        "label": "ET: Debbie’s Single Life season 2 reset",
        "url": "https://www.etonline.com/90-day-fiance-debbie-tearfully-calls-son-colt-a-basrd-for-kicking-her-out-on-the-street-175018"
      },
      {
        "label": "ET: Debbie decides to move to Canada",
        "url": "https://www.etonline.com/90-day-the-single-life-debbie-decides-to-move-to-canada-tony-wants-to-meet-colt-exclusive-192976"
      },
      {
        "label": "TLC: Debbie visits Cortney in The Single Life season 5",
        "url": "https://www.tlc.com/shows/90-day-the-single-life/photo-galleries/90-day-the-single-life-season-5-drama-episodes-recap"
      }
    ]
  },
  {
    "personId": "p-fernanda-flores",
    "headline": "A Mexico meet-cute became a marriage, a divorce, and a fresh dating chapter with actual gym chemistry.",
    "bio": [
      "Fernanda joined 90 Day Fiancé with Jonathan after they met at a club in Mexico. Their quick engagement and U.S. wedding gave way to a separation, with the divorce finalized in 2020.",
      "The Single Life caught her rebuilding in Chicago and getting to know Robby. Her later relationship with boxer Noel began at a Miami gym, where the introduction apparently included pizza rather than a perfectly choreographed workout."
    ],
    "originStory": "Jonathan met Fernanda on vacation in Mexico, proposed three months later, and their international relationship became a Season 6 story.",
    "journeys": [
      {
        "label": "Where it started: Fernanda & Jonathan",
        "partnerName": "Jonathan Rivera",
        "relationshipId": "ARC-1A6AC0C11EFF",
        "era": "90 Day Fiancé S6",
        "summary": "Their engagement led to marriage in 2018; their divorce was finalized in March 2020."
      },
      {
        "label": "The dating reset",
        "partnerName": "Robby and Noel Mikaelian",
        "era": "The Single Life S1 and later",
        "summary": "Fernanda explored dating Robby and subsequently reported a relationship with Noel, whom she met at a gym."
      }
    ],
    "sources": [
      {
        "label": "ET: Fernanda’s post-divorce dating chapter",
        "url": "https://www.etonline.com/90-day-the-single-life-fernanda-breaks-down-over-ex-jonathan-and-his-new-fiancee-exclusive-161108"
      },
      {
        "label": "Distractify: Fernanda and Noel’s gym introduction",
        "url": "https://www.distractify.com/p/fernanda-90-day-fiance-boyfriend"
      }
    ]
  },
  {
    "personId": "p-brittany-banks",
    "headline": "A Jordan romance and a dating reset that left plenty of room for her own opinions.",
    "bio": [
      "Brittany entered The Other Way with Yazan after a video-call introduction through his sister. She traveled to Jordan with a relationship plan, but their expectations about religion and family did not line up neatly.",
      "After that chapter ended, The Single Life followed her dates with Terence and Justin. Choosing a compatible partner became its own project; this time the options came with far fewer international travel arrangements."
    ],
    "originStory": "A video call through Yazan’s sister introduced them, leading Brittany to pursue the relationship in Jordan on The Other Way Season 2.",
    "journeys": [
      {
        "label": "Where it started: Brittany & Yazan",
        "partnerName": "Yazan Abo Horira",
        "relationshipId": "ARC-97EBA9D0AEA9",
        "era": "The Other Way S2",
        "summary": "Their long-distance romance faced major differences over religion and family; her subsequent Single Life season followed a dating reset."
      },
      {
        "label": "Later dating possibilities",
        "partnerName": "Terence and Justin",
        "era": "The Single Life S1",
        "summary": "Brittany weighed two dating connections rather than continuing her Jordan relationship."
      },
      {
        "label": "The next chapter — announced",
        "era": "Hunt for Love S2",
        "summary": "TLC has announced a Puerto Rico return beginning October 5, 2026. No new partner or aired storyline is claimed."
      }
    ],
    "sources": [
      {
        "label": "The Cinemaholic: Brittany and Yazan’s introduction",
        "url": "https://thecinemaholic.com/brittany-and-yazan/"
      },
      {
        "label": "TV Insider: The Single Life premiere recap",
        "url": "https://www.tvinsider.com/988424/90-day-the-single-life-premiere-bringing-sexy-back-recap/"
      },
      {
        "label": "TLC: Hunt for Love season 2 singles (announced)",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-season-2-singles-bios-photos"
      }
    ]
  },
  {
    "personId": "p-caesar-mack",
    "headline": "A North Carolina nail technician whose long-distance hopes kept requiring another itinerary.",
    "bio": [
      "Caesar first appeared with an online relationship involving Maria in Ukraine. Before the 90 Days followed his hopes of finally meeting her, with a planned Mexico trip becoming a painful disappointment.",
      "On The Single Life he returned to dating with help from a matchmaker in Kyiv. His story shifted toward finding a reciprocal connection, with optimism still occupying more suitcase space than most airlines recommend."
    ],
    "originStory": "Caesar’s years of online contact with Maria led to his first Before the 90 Days story and a planned first meeting in Mexico.",
    "journeys": [
      {
        "label": "Where it started: Caesar & Maria",
        "partnerName": "Maria",
        "relationshipId": "ARC-8B35A0FBCB33",
        "era": "Before the 90 Days S3",
        "summary": "The online relationship and unsuccessful meeting plan introduced Caesar; later dating seasons followed a new search."
      },
      {
        "label": "A matchmaking chapter",
        "era": "The Single Life S3",
        "summary": "Caesar enlisted a professional Kyiv matchmaker in hopes of meeting a compatible partner in person."
      }
    ],
    "sources": [
      {
        "label": "ET: Caesar and Maria’s Before the 90 Days story",
        "url": "https://www.etonline.com/90-day-fiance-before-the-90-days-bombshell-caesars-ukrainian-girlfriend-is-finally-revealed-135163"
      },
      {
        "label": "Us Weekly: TLC’s Single Life season 3 cast announcement",
        "url": "https://www.usmagazine.com/entertainment/pictures/90-day-the-single-life-season-3-meet-the-cast/"
      }
    ]
  },
  {
    "personId": "p-corey-rathgeber",
    "headline": "A backpacking stop became a life in Ecuador—and a wedding with an unusually long preamble.",
    "bio": [
      "Corey met Evelin on a beach during a backpacking trip in Ecuador. After time together in the U.S., he followed her back, trading familiar surroundings for a new home and a beach-bar venture.",
      "Their return season revealed a secret marriage while they planned a public wedding. A relationship with Jenny during time apart complicated reconciliation; the guest list was not the only thing needing careful management."
    ],
    "originStory": "A beach meeting in Ecuador led to a relationship; The Other Way Season 1 followed Corey’s decision to move there to be with Evelin.",
    "journeys": [
      {
        "label": "Where it started: Corey & Evelin",
        "partnerName": "Evelin Villegas",
        "relationshipId": "ARC-E196BA6D9016",
        "era": "The Other Way S1 · S3",
        "summary": "Their Ecuador life included a proposal, a privately completed marriage and a later wedding-planning season."
      },
      {
        "label": "A relationship during time apart",
        "partnerName": "Jenny",
        "era": "Discussed in The Other Way S3",
        "summary": "Corey acknowledged another relationship in Peru, which became a major trust issue when he and Evelin reunited."
      }
    ],
    "sources": [
      {
        "label": "TLC: Corey and Evelin’s journey",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/90-day-the-other-way-journey-corey-and-evelin"
      },
      {
        "label": "ET: Corey and Evelin’s secret marriage",
        "url": "https://www.etonline.com/90-day-fiance-evelin-reveals-she-and-corey-secretly-got-married-171957"
      }
    ]
  },
  {
    "personId": "p-evelin-villegas",
    "headline": "Ecuador’s beach-bar chapter had a proposal, a secret marriage, and very opinionated wedding planning.",
    "bio": [
      "Evelin met Corey while he was backpacking in Ecuador. After trying life with him in the U.S., she returned home and he followed, making their relationship one of The Other Way’s original stories.",
      "Season 3 brought a revelation that they had married privately before their public wedding plans. Corey’s Peru relationship and her family’s concerns turned preparations into considerably more than choosing centerpieces."
    ],
    "originStory": "Evelin’s Ecuador beach meeting with Corey became a cross-border relationship, and The Other Way began following his move to her home country in Season 1.",
    "journeys": [
      {
        "label": "Where it started: Evelin & Corey",
        "partnerName": "Corey Rathgeber",
        "relationshipId": "ARC-E196BA6D9016",
        "era": "The Other Way S1 · S3",
        "summary": "A backpacking encounter became life together in Ecuador, an engagement and a privately completed marriage revealed during wedding planning."
      }
    ],
    "sources": [
      {
        "label": "TLC: Corey and Evelin’s journey",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/90-day-the-other-way-journey-corey-and-evelin"
      },
      {
        "label": "ET: Corey and Evelin’s secret marriage",
        "url": "https://www.etonline.com/90-day-fiance-evelin-reveals-she-and-corey-secretly-got-married-171957"
      }
    ]
  },
  {
    "personId": "p-steven-johnston",
    "headline": "Language practice became a Turkey wedding plan with several difficult conversations before the vows.",
    "bio": [
      "Steven, a Mormon from Utah, met Alina on a language-learning app. Pandemic travel restrictions pushed their plan toward Turkey rather than a direct move to Russia.",
      "The Other Way followed questions about honesty, religious expectations and his contact with other women before a proposal and wedding. A boat and a piano supplied the romance, but neither could handle the trust conversations for him."
    ],
    "originStory": "Steven and Alina met through language practice online, then reunited in Turkey to pursue marriage on The Other Way Season 3.",
    "journeys": [
      {
        "label": "Where it started: Steven & Alina",
        "partnerName": "Alina Shaimardanova",
        "relationshipId": "ARC-0B785EDADA04",
        "era": "The Other Way S3",
        "summary": "Their online connection led to a Turkey reunion, engagement and wedding amid disagreements about trust and religion."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 3 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/90-day-fiance-the-other-way-season-3-new-couples-photos"
      },
      {
        "label": "ET: Steven discusses his relationship with Alina",
        "url": "https://www.etonline.com/90-day-fiance-steven-explains-why-he-asked-alina-if-he-could-date-other-women-exclusive-171644"
      },
      {
        "label": "ET: Steven proposes to Alina",
        "url": "https://www.etonline.com/90-day-fiance-steven-cries-as-he-proposes-to-alina-174502"
      },
      {
        "label": "Hollywood Life: Steven and Alina’s Turkey wedding",
        "url": "https://hollywoodlife.com/2021/11/23/steven-johnston-alina-married-90-day-fiance/"
      }
    ]
  },
  {
    "personId": "p-alina-shaimardanova",
    "headline": "A Russian language student followed an online romance to Turkey, with trust firmly on the itinerary.",
    "bio": [
      "Alina met Steven through a language-learning app and paused college plans to pursue their relationship. With pandemic travel rules complicating Russia, Turkey became their meeting place and wedding destination.",
      "Her first season explored whether Steven’s behavior matched the religious standards he asked her to follow. A romantic proposal led to marriage, but Alina’s questions about honesty remained firmly on the itinerary."
    ],
    "originStory": "Alina’s language-app connection with Steven led to the couple’s Turkey reunion on The Other Way Season 3.",
    "journeys": [
      {
        "label": "Where it started: Alina & Steven",
        "partnerName": "Steven Johnston",
        "relationshipId": "ARC-0B785EDADA04",
        "era": "The Other Way S3",
        "summary": "Language practice grew into an international engagement and Turkey wedding; trust and religious expectations shaped the season."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 3 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/90-day-fiance-the-other-way-season-3-new-couples-photos"
      },
      {
        "label": "ET: Steven discusses his relationship with Alina",
        "url": "https://www.etonline.com/90-day-fiance-steven-explains-why-he-asked-alina-if-he-could-date-other-women-exclusive-171644"
      },
      {
        "label": "ET: Steven proposes to Alina",
        "url": "https://www.etonline.com/90-day-fiance-steven-cries-as-he-proposes-to-alina-174502"
      },
      {
        "label": "Hollywood Life: Steven and Alina’s Turkey wedding",
        "url": "https://hollywoodlife.com/2021/11/23/steven-johnston-alina-married-90-day-fiance/"
      }
    ]
  },
  {
    "personId": "p-ellie-rose",
    "headline": "A Seattle pizza business gave way to a Providencia plan—and a very serious reunion.",
    "bio": [
      "Ellie met Victor while vacationing on Colombia’s island of Providencia. Their long-distance connection inspired her to leave her Seattle routine and pizza business for a life together.",
      "Before their reunion, a devastating hurricane struck Victor’s island. The Other Way followed the relief of finding him safe and the work of rebuilding while also addressing trust and money—far beyond the usual moving-day checklist."
    ],
    "originStory": "A vacation meeting with Victor led Ellie to plan a move from Seattle to Providencia, the relationship followed on The Other Way Season 3.",
    "journeys": [
      {
        "label": "Where it started: Ellie & Victor",
        "partnerName": "Victor McLean",
        "relationshipId": "ARC-9A663F14F339",
        "era": "The Other Way S3",
        "summary": "Their vacation romance became a relocation plan, a reunion after a hurricane and difficult conversations about rebuilding their life together."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 3 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/90-day-fiance-the-other-way-season-3-new-couples-photos"
      },
      {
        "label": "ET: Ellie and Victor’s reunion after the hurricane",
        "url": "https://www.etonline.com/90-day-fiance-ellie-emotionally-reunites-with-victor-after-category-5-hurricane-172499"
      }
    ]
  },
  {
    "personId": "p-victor-mclean",
    "headline": "Providencia’s island romance became a reunion and rebuilding story before everyday couple life could settle in.",
    "bio": [
      "Victor met Seattle resident Ellie while she was vacationing in Providencia. Their long-distance relationship eventually brought her back with plans for a shared life on the island.",
      "A catastrophic hurricane transformed that plan. Victor survived with his family, and his reunion with Ellie became a defining part of their season before they faced rebuilding decisions. Their shared-life checklist now involved much more than choosing which side of the bed was whose."
    ],
    "originStory": "Victor’s vacation connection with Ellie led to her planned move to Providencia and their first appearance on The Other Way Season 3.",
    "journeys": [
      {
        "label": "Where it started: Victor & Ellie",
        "partnerName": "Ellie Rose",
        "relationshipId": "ARC-9A663F14F339",
        "era": "The Other Way S3",
        "summary": "An island meeting grew into a long-distance romance and relocation plan, interrupted by a devastating hurricane."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 3 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/90-day-fiance-the-other-way-season-3-new-couples-photos"
      },
      {
        "label": "ET: Ellie and Victor’s reunion after the hurricane",
        "url": "https://www.etonline.com/90-day-fiance-ellie-emotionally-reunites-with-victor-after-category-5-hurricane-172499"
      }
    ]
  },
  {
    "personId": "p-stephanie-matto",
    "headline": "An online Australia romance became a fresh U.S. dating chapter, with no shortage of candid conversation.",
    "bio": [
      "Stephanie met Erika online and traveled to Australia to see whether their long-distance connection worked in person. Their Before the 90 Days story was the series’ first featured same-sex couple.",
      "After that romance ended, The Single Life followed Stephanie’s return to dating. A date with Dave and interest in hairdresser Steph brought new possibilities, proving that even a shared first name does not automatically establish chemistry."
    ],
    "originStory": "Stephanie’s online relationship with Erika led to her Australia visit on Before the 90 Days Season 4.",
    "journeys": [
      {
        "label": "Where it started: Stephanie & Erika",
        "partnerName": "Erika Owens",
        "relationshipId": "ARC-E80C906E26A4",
        "era": "Before the 90 Days S4",
        "summary": "Their first in-person visit exposed differences about intimacy, friendships and coming out; the couple split before Stephanie returned home."
      },
      {
        "label": "Dating again at home",
        "partnerName": "Dave and Steph",
        "era": "The Single Life S2",
        "summary": "Stephanie explored new dates after her relationship with Erika, including an interest in her hairdresser."
      }
    ],
    "sources": [
      {
        "label": "TLC: Stephanie’s journey",
        "url": "https://www.tlc.com/shows/90-day-fiance/photo-galleries/stephanie-journey-so-far"
      }
    ]
  },
  {
    "personId": "p-kelly-brown",
    "headline": "Molly’s message sparked a Georgia romance that eventually faced a difficult retreat goodbye.",
    "bio": [
      "Kelly entered the franchise as Molly’s New York-based boyfriend after connecting through messages. The Single Life followed his visit to Georgia as she considered whether he fit into her family.",
      "The pair later tried therapy on The Last Resort while already struggling. Their retreat ended in a mutual goodbye rather than recommitment, making this one of the franchise’s more poignant checkouts."
    ],
    "originStory": "Kelly connected with Molly online and visited her in Georgia during The Single Life Season 1.",
    "journeys": [
      {
        "label": "Where it started: Kelly & Molly",
        "partnerName": "Molly Hopkins",
        "relationshipId": "ARC-360783C5EC56",
        "era": "The Single Life S1 · The Last Resort S1",
        "summary": "The online connection became a relationship and later retreat therapy; they agreed to split during the 2023 season."
      }
    ],
    "sources": [
      {
        "label": "TV Insider: The Single Life premiere recap",
        "url": "https://www.tvinsider.com/988424/90-day-the-single-life-premiere-bringing-sexy-back-recap/"
      },
      {
        "label": "TLC: The Last Resort season 1 couples",
        "url": "https://www.tlc.com/shows/90-day-the-last-resort/photo-galleries/90-Day-Fiance-The-Last-Resort-Couples-Bios"
      },
      {
        "label": "ET: Molly and Kelly’s retreat goodbye",
        "url": "https://www.etonline.com/90-day-the-last-resort-recap-kelly-and-molly-split-and-share-a-heartbreaking-goodbye-212219"
      }
    ]
  },
  {
    "personId": "p-vanessa-guerra-colt-arc",
    "headline": "A longtime friendship with Colt grew into an engagement, with trust requiring more than a ring.",
    "bio": [
      "Vanessa was a close friend and romantic interest in Colt’s life before their relationship became The Single Life’s focus. She knew his dating history and had understandable reservations about taking the next step.",
      "Colt proposed during the first season, and she accepted cautiously. Their relationship later ended; the original friendship-to-romance chapter still explains her place in the franchise better than treating her as somebody who simply appeared for a tell-all."
    ],
    "originStory": "Vanessa entered through her friendship and developing romance with Colt; The Single Life Season 1 followed their decision to try a committed relationship.",
    "journeys": [
      {
        "label": "Where it started: Vanessa & Colt",
        "partnerName": "Colt Johnson",
        "relationshipId": "ARC-41C27194D3BC",
        "era": "The Single Life S1 and after",
        "summary": "A longstanding friendship became an engagement and marriage; TLC’s subsequent Hunt for Love introduction confirms their split."
      }
    ],
    "sources": [
      {
        "label": "ET: Colt proposes to Vanessa",
        "url": "https://www.etonline.com/90-day-fiances-colt-and-vanessa-are-engaged-165306"
      },
      {
        "label": "TLC: Hunt for Love’s returning singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-meet-the-90-day-singles"
      }
    ]
  },
  {
    "personId": "p-giannis-chantel-arc",
    "headline": "A Greek soccer player became the unexpected romantic stop on Chantel’s post-divorce trip.",
    "bio": [
      "Giannis met Chantel during her trip to Greece with friends. Their attraction introduced him to The Single Life as she explored dating after the end of her marriage to Pedro.",
      "Dates and travel around Crete gave them time to discuss family and whether distance could work. It was a holiday spark with real questions attached, rather than a confirmed engagement hidden inside a vacation itinerary."
    ],
    "originStory": "Chantel met Giannis at a club in Greece during her post-divorce trip, bringing their connection into The Single Life Season 4.",
    "journeys": [
      {
        "label": "Where it started: Giannis & Chantel",
        "partnerName": "Chantel Everett",
        "relationshipId": "ARC-1B2F99EAC8E9",
        "era": "The Single Life S4",
        "summary": "A Greece vacation introduced their flirtation and dates; no ongoing relationship or legal status is confirmed here."
      }
    ],
    "sources": [
      {
        "label": "The Cinemaholic: Chantel and Giannis’s Greek connection",
        "url": "https://thecinemaholic.com/chantel-giannis/"
      },
      {
        "label": "TheTVDB: The Single Life season 4 story descriptions",
        "url": "https://thetvdb.com/series/90-day-the-single-life/allseasons/official"
      }
    ]
  },
  {
    "personId": "p-nicole-sherbiny",
    "headline": "A fabric-shop meet-cute became a marriage with two very different dress codes.",
    "bio": [
      "Nicole’s Egypt trip took an unexpected turn when she met Mahmoud in a fabric shop. His first-day proposal eventually brought her back for a wedding—an impressive upgrade from the usual vacation souvenir.",
      "The Other Way followed Nicole’s attempt to build a married life in Egypt. Happily Ever After reversed the direction when Mahmoud moved to Los Angeles, giving both spouses a turn at being the newcomer and putting their different expectations under the same roof."
    ],
    "originStory": "Nicole met Mahmoud during a trip to Egypt and returned three weeks later to marry him. Their cross-cultural marriage introduced them on The Other Way Season 4.",
    "journeys": [
      {
        "label": "Where it started: Nicole & Mahmoud",
        "partnerName": "Mahmoud El Sherbiny",
        "relationshipId": "ARC-2374C52AC619",
        "era": "The Other Way S4 · Happily Ever After S8",
        "summary": "Their marriage began in Egypt and continued on television in Los Angeles. These seasons document the relationship then; its present status needs a newer verified source."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 4 introductions",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/meet-the-new-season-couples-90-day-fiance-the-other-way"
      },
      {
        "label": "TLC: Happily Ever After season 8 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-happily-ever-after/photo-galleries/90-day-fiance-happily-ever-after-couples-bios-season-8"
      }
    ]
  },
  {
    "personId": "p-mahmoud-el-sherbiny",
    "headline": "From an Egyptian fabric shop to Los Angeles, with marriage doing the navigating.",
    "bio": [
      "Mahmoud met Nicole while she was shopping in Egypt, and his interest moved considerably faster than a leisurely browsing session. They married after her return trip, creating a cross-cultural relationship before the cameras followed their home life.",
      "His first featured season took place in Egypt, where Nicole struggled with expectations about clothing and everyday life. Their later Los Angeles chapter put Mahmoud in unfamiliar surroundings instead: same couple, different person searching for the comfort of home."
    ],
    "originStory": "Mahmoud’s marriage to visiting American Nicole brought him into The Other Way Season 4; Happily Ever After Season 8 later followed his move to her Los Angeles home.",
    "journeys": [
      {
        "label": "Where it started: Mahmoud & Nicole",
        "partnerName": "Nicole Sherbiny",
        "relationshipId": "ARC-2374C52AC619",
        "era": "The Other Way S4 · Happily Ever After S8",
        "summary": "Their televised story centers on the marriage that began in Egypt. Later legal or relationship developments are not established by these season introductions."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 4 introductions",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/meet-the-new-season-couples-90-day-fiance-the-other-way"
      },
      {
        "label": "TLC: Happily Ever After season 8 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-happily-ever-after/photo-galleries/90-day-fiance-happily-ever-after-couples-bios-season-8"
      }
    ]
  },
  {
    "personId": "p-corona-blakey",
    "headline": "A midwifery dream, an Icelandic romance and a very chilly reality check.",
    "bio": [
      "Corona was training to become a midwife when a connection with Ingi in Iceland changed her plans. Choosing love meant stepping away from a coveted educational opportunity—an unusually high-stakes version of changing your itinerary.",
      "Her move made practical questions unavoidable: could she continue her training in Iceland, and did Ingi want the same future? Their season brought career ambitions and relationship expectations into focus, with scenic views doing very little of the actual negotiating."
    ],
    "originStory": "Corona met Ingi during a visit to Iceland and moved there to pursue the relationship on The Other Way Season 6.",
    "journeys": [
      {
        "label": "Where it started: Corona & Ingi",
        "partnerName": "Ingi Hilmar",
        "relationshipId": "ARC-65C0C2DD941E",
        "era": "The Other Way S6",
        "summary": "Her move to Iceland tested whether their early connection could support a shared future. The tell-all reported a breakup; this biography does not infer their current lives from social media."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 6 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-6-couples-photos-bios"
      },
      {
        "label": "The Escapist: Corona and Ingi’s season story",
        "url": "https://www.escapistmagazine.com/90-day-fiance-are-corona-ingi-still-together/"
      }
    ]
  },
  {
    "personId": "p-ingi-hilmar",
    "headline": "Icelandic low-key meets a relocation that was anything but.",
    "bio": [
      "Ingi’s connection with visiting American Corona turned into an international relationship when she moved to Iceland. TLC introduced him as someone with limited relationship experience, suddenly facing a considerably larger commitment than a holiday romance.",
      "Corona arrived with career goals and hopes for a long-term future; Ingi had to decide what building that future meant to him. The Other Way gave their different speeds a spotlight—romance, it turns out, does not come with a shared calendar invite."
    ],
    "originStory": "Ingi joined The Other Way Season 6 through his relationship with Corona and her decision to relocate to Iceland.",
    "journeys": [
      {
        "label": "Where it started: Ingi & Corona",
        "partnerName": "Corona Blakey",
        "relationshipId": "ARC-65C0C2DD941E",
        "era": "The Other Way S6",
        "summary": "The season followed Corona’s move and their differing commitment expectations. A season-end breakup was reported; no newer current-status verification is claimed here."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 6 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-6-couples-photos-bios"
      },
      {
        "label": "The Escapist: Corona and Ingi’s season story",
        "url": "https://www.escapistmagazine.com/90-day-fiance-are-corona-ingi-still-together/"
      }
    ]
  },
  {
    "personId": "p-joanne-digesu",
    "headline": "An Irish marriage, two sons and a family announcement nobody could put on mute.",
    "bio": [
      "Joanne entered The Other Way with a major detail already in place: she and Sean were secretly married. Her New York-to-Ireland plans involved more than a passport, because her two sons needed to understand the marriage and what it meant for their family.",
      "The reveal became the heart of their season. Joanne wanted time with Sean without leaving her children feeling sidelined, turning a romantic relocation into a delicate family negotiation. Even the prettiest Irish scenery cannot answer a teenager’s follow-up questions."
    ],
    "originStory": "Joanne’s secret marriage to Sean and plans to join him in Ireland introduced her on The Other Way Season 6.",
    "journeys": [
      {
        "label": "Where it started: Joanne & Sean",
        "partnerName": "Sean",
        "relationshipId": "ARC-8E692C75457B",
        "era": "The Other Way S6",
        "summary": "They were already married when the season began, but had kept the news from their families. Present marital status requires a newer source than the season’s reveal."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 6 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-6-couples-photos-bios"
      },
      {
        "label": "Reality TV World: Joanne, Sean, Josh and Lily’s family conversations",
        "url": "https://www.realitytvworld.com/news/90-day-fiance-other-way-recap-meitalia-starts-give-up-and-shekinah-gets-nose-job-34289.php"
      }
    ]
  },
  {
    "personId": "p-sean-tow-s6",
    "headline": "The Irish husband with a wedding already done and a family introduction still pending.",
    "bio": [
      "Sean was already married to Joanne when they appeared on The Other Way, but the people closest to them had not been told. Meeting Joanne’s sons in Ireland therefore came with a rather substantial item on the agenda.",
      "He wanted a life with Joanne while also having to address the pain caused by their secrecy. His apologies and the children’s concerns gave the season a family focus: the vows were finished, but the conversations were just getting started."
    ],
    "originStory": "Sean joined The Other Way Season 6 through his secret marriage to New Yorker Joanne and her proposed move to Ireland.",
    "journeys": [
      {
        "label": "Where it started: Sean & Joanne",
        "partnerName": "Joanne DiGesu",
        "relationshipId": "ARC-8E692C75457B",
        "era": "The Other Way S6",
        "summary": "Their marriage predated the televised family introductions. This season establishes their marriage then, not a freshly verified current-status update."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 6 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-6-couples-photos-bios"
      },
      {
        "label": "Reality TV World: Joanne, Sean, Josh and Lily’s family conversations",
        "url": "https://www.realitytvworld.com/news/90-day-fiance-other-way-recap-meitalia-starts-give-up-and-shekinah-gets-nose-job-34289.php"
      }
    ]
  },
  {
    "personId": "p-josh-mcguffey",
    "headline": "A language-app match became married life in China, with finances needing their own translator.",
    "bio": [
      "Josh met Lily on a language-learning app, and their conversations became a marriage. He left his job in South Carolina to join her in China—a much bigger commitment than maintaining an app streak.",
      "Once there, Lily’s role as the household earner and their different expectations about money became recurring tensions. Josh’s brother Jarod also stepped into the conversations before their wedding celebration, reminding everyone that a ceremony does not settle the household budget."
    ],
    "originStory": "Josh joined The Other Way Season 6 after marrying Lily and relocating to China to live with her.",
    "journeys": [
      {
        "label": "Where it started: Josh & Lily",
        "partnerName": "Lily Huang",
        "relationshipId": "ARC-1D15E984ED3C",
        "era": "The Other Way S6",
        "summary": "Their language-app connection became a marriage before his China move. The season’s relationship difficulties are documented, but a present-day status is not verified here."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 6 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-6-couples-photos-bios"
      },
      {
        "label": "Distractify: Josh and Lily’s China chapter",
        "url": "https://www.distractify.com/p/josh-and-lily-still-together-90-day-fiance-the-other-way"
      },
      {
        "label": "Reality TV World: Joanne, Sean, Josh and Lily’s family conversations",
        "url": "https://www.realitytvworld.com/news/90-day-fiance-other-way-recap-meitalia-starts-give-up-and-shekinah-gets-nose-job-34289.php"
      }
    ]
  },
  {
    "personId": "p-lily-huang",
    "headline": "A Chinese businesswoman whose international romance came with a household-budget subplot.",
    "bio": [
      "Lily’s language-learning app introduced her to Josh, eventually turning practice conversations into a marriage. Their featured season began with him moving from South Carolina to China to share her life.",
      "As the couple’s earner, Lily wanted her work and investment in their home to be appreciated. Josh’s adjustment and their communication problems complicated the wedding celebration; speaking the same language was only one item on the relationship homework list."
    ],
    "originStory": "Lily’s marriage to Josh and his move into her life in China brought her to The Other Way Season 6.",
    "journeys": [
      {
        "label": "Where it started: Lily & Josh",
        "partnerName": "Josh McGuffey",
        "relationshipId": "ARC-1D15E984ED3C",
        "era": "The Other Way S6",
        "summary": "They met through a language app and married before the relocation. Their on-screen conflict does not by itself prove a current separation or divorce."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 6 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-6-couples-photos-bios"
      },
      {
        "label": "Distractify: Josh and Lily’s China chapter",
        "url": "https://www.distractify.com/p/josh-and-lily-still-together-90-day-fiance-the-other-way"
      },
      {
        "label": "Reality TV World: Joanne, Sean, Josh and Lily’s family conversations",
        "url": "https://www.realitytvworld.com/news/90-day-fiance-other-way-recap-meitalia-starts-give-up-and-shekinah-gets-nose-job-34289.php"
      }
    ]
  },
  {
    "personId": "p-greta-matthew-arc",
    "headline": "A vegan-app match tested whether shared values could survive a shared address.",
    "bio": [
      "Greta, an Oklahoma lawyer and animal lover, met English finance professional Matthew through a vegan dating app. Their shared interests and long-distance connection led her to move to his English hometown, where his parents were part of the living arrangement.",
      "The visit quickly exposed differences that online compatibility had not resolved, including their hopes about children and everyday connection. A later interview described their breakup and Greta’s own life in the United Kingdom: same country, revised relationship itinerary."
    ],
    "originStory": "Greta’s move from Oklahoma to England to join Matthew brought them to The Other Way Season 7 after several years of long-distance dating.",
    "journeys": [
      {
        "label": "Where it started: Greta & Matthew",
        "partnerName": "Matthew",
        "relationshipId": "ARC-195717FD4F4B",
        "era": "The Other Way S7",
        "summary": "They met on a vegan dating app. Their season documented a breakup after Greta’s arrival; a January 2026 interview discussed their separate new relationships without identifying new partners."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "TV Insider: Greta and Matthew’s relationship history",
        "url": "https://www.tvinsider.com/swooon/1243173/90-day-fiance-the-other-way-greta-matthew-still-together-updates/"
      },
      {
        "label": "TV Insider: Greta’s post-season interview",
        "url": "https://www.tvinsider.com/swooon/1259337/90-day-fiance-greta-new-relationship-other-way-tell-all-interview/"
      }
    ]
  },
  {
    "personId": "p-matthew-greta-arc",
    "headline": "An English homebody whose long-distance romance needed more than matching app settings.",
    "bio": [
      "Matthew, a finance professional from England, connected with Greta on a vegan dating app. Their relationship crossed the Atlantic before she arrived to live in his hometown alongside him and his parents.",
      "Sharing principles did not mean sharing every plan. The Other Way followed the gap between their long-distance bond and life together, including disagreement about children; their eventual breakup gave this match a different ending from the one booked into the itinerary."
    ],
    "originStory": "Matthew joined The Other Way Season 7 when his American girlfriend Greta moved to England after their long-distance relationship.",
    "journeys": [
      {
        "label": "Where it started: Matthew & Greta",
        "partnerName": "Greta",
        "relationshipId": "ARC-195717FD4F4B",
        "era": "The Other Way S7",
        "summary": "Their vegan-app match ended during Greta’s England visit. The reported January 2026 update described both moving on, not an ongoing couple."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "TV Insider: Greta and Matthew’s relationship history",
        "url": "https://www.tvinsider.com/swooon/1243173/90-day-fiance-the-other-way-greta-matthew-still-together-updates/"
      },
      {
        "label": "TV Insider: Greta’s post-season interview",
        "url": "https://www.tvinsider.com/swooon/1259337/90-day-fiance-greta-new-relationship-other-way-tell-all-interview/"
      }
    ]
  },
  {
    "personId": "p-anthony-manon-arc",
    "headline": "A stay-at-home dad hoping a French reset could do more than a change of scenery.",
    "bio": [
      "Anthony and Manon arrived in the franchise as an already-married couple raising their son Benjamin. With married life and parenting wearing them down in California, they made France the setting for a relationship reset.",
      "Anthony’s stay-at-home parenting role and Manon’s work as a content creator shaped their daily routine. Relocating closer to her family added support, but also questions about money and personal space—hardly the uncomplicated version of France found on a postcard."
    ],
    "originStory": "Anthony’s existing marriage to French wife Manon, and their decision to move with their son to France, introduced them on The Other Way Season 7.",
    "journeys": [
      {
        "label": "Where it started: Anthony & Manon",
        "partnerName": "Manon",
        "relationshipId": "ARC-7C656AE6A109",
        "era": "The Other Way S7",
        "summary": "They entered television already married and parenting Benjamin. The sources establish their relocation and marital strain, not the circumstances of their very first meeting or a newly verified current status."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "TV Insider: Manon and Anthony’s France move",
        "url": "https://www.tvinsider.com/swooon/1239204/90-day-fiance-the-other-way-manon-anthony-still-together-son/"
      }
    ]
  },
  {
    "personId": "p-manon-anthony-arc",
    "headline": "A French mother returning home, with a marriage reset sharing space with family life.",
    "bio": [
      "Manon is a French content creator whose marriage to Anthony and life with son Benjamin became their first franchise storyline. Their California routine had left them feeling stretched, so she hoped returning to France could help the family breathe.",
      "The move brought Anthony into her home-country world, where family involvement and financial pressure remained very much part of the picture. A new address offered possibility; it did not automatically grant this couple a quiet room for every difficult conversation."
    ],
    "originStory": "Manon and Anthony joined The Other Way Season 7 as married parents moving from California to France in hopes of strengthening their relationship.",
    "journeys": [
      {
        "label": "Where it started: Manon & Anthony",
        "partnerName": "Anthony",
        "relationshipId": "ARC-7C656AE6A109",
        "era": "The Other Way S7",
        "summary": "Their original televised relationship is their existing marriage. How they first met is not established by these sources, so this profile does not invent a meet-cute."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "TV Insider: Manon and Anthony’s France move",
        "url": "https://www.tvinsider.com/swooon/1239204/90-day-fiance-the-other-way-manon-anthony-still-together-son/"
      }
    ]
  },
  {
    "personId": "p-pattiya-dylan-arc",
    "headline": "A decade-long, on-and-off romance finally asked the suitcases to commit.",
    "bio": [
      "Pattiya, an exotic dancer from Texas, had spent more than a decade in an on-and-off relationship with Dylan before their featured season. Moving to Tasmania meant finding out whether a long-distance pattern could become an everyday partnership.",
      "Her Australian boyfriend is a plumber who also strips, and their twenty-year age difference was only one adjustment on the list. Trust and living near his mother gave the move extra layers: romance arrived with a neighborhood orientation."
    ],
    "originStory": "Pattiya’s move from Texas to Tasmania to join longtime boyfriend Dylan introduced them on The Other Way Season 7.",
    "journeys": [
      {
        "label": "Where it started: Pattiya & Dylan",
        "partnerName": "Dylan",
        "relationshipId": "ARC-D3D9F5B27934",
        "era": "The Other Way S7",
        "summary": "Their long-running, intermittent relationship became a relocation story. The sources do not confirm the precise setting of their first meeting or an up-to-date relationship outcome."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "Extra: Pattiya and Dylan’s introduction",
        "url": "https://extratv.com/2025/10/09/90-day-fiance-meet-pattiya-and-her-much-younger-plumber-stripper-bf-dylan-exclusive-clip/"
      }
    ]
  },
  {
    "personId": "p-dylan-pattiya-arc",
    "headline": "A Tasmanian plumber with two careers and one long-distance relationship to settle.",
    "bio": [
      "Dylan’s relationship with Texas dancer Pattiya lasted more than a decade on and off before she moved to Australia. TLC introduced their twenty-year age difference and the practical question of whether they could make a stable home together.",
      "Working as both a plumber and a stripper gave Dylan a distinctive introduction, but trust became the more important storyline. With his mother close by and Pattiya adjusting to Tasmania, there was plenty to work through that no toolbox could fix."
    ],
    "originStory": "Dylan joined The Other Way Season 7 when longtime American girlfriend Pattiya moved to Tasmania to pursue their relationship.",
    "journeys": [
      {
        "label": "Where it started: Dylan & Pattiya",
        "partnerName": "Pattiya",
        "relationshipId": "ARC-D3D9F5B27934",
        "era": "The Other Way S7",
        "summary": "Their established long-distance romance supplied the show’s starting point. A precise first-meeting account and freshly verified current status remain unconfirmed."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "Extra: Pattiya and Dylan’s introduction",
        "url": "https://extratv.com/2025/10/09/90-day-fiance-meet-pattiya-and-her-much-younger-plumber-stripper-bf-dylan-exclusive-clip/"
      }
    ]
  },
  {
    "personId": "p-chloe",
    "headline": "An Aruba vacation romance that had to work after the holiday clothes were unpacked.",
    "bio": [
      "Chloe met Johny while vacationing in Aruba, where he worked as a pirate-boat tour guide. The connection inspired her to leave Boston for island life with him, taking their relationship out of vacation mode.",
      "His people-facing job and her family’s doubts became important parts of their season. Trust problems eventually led to a breakup confirmed at the tell-all; the tropical backdrop remained lovely, but it could not do the couple’s communication for them."
    ],
    "originStory": "Chloe’s Aruba vacation meeting with Johny, and her subsequent move from Massachusetts to live with him, brought her to The Other Way Season 7.",
    "journeys": [
      {
        "label": "Where it started: Chloe & Johny",
        "partnerName": "Johny",
        "relationshipId": "ARC-5A3C5BB262AF",
        "era": "The Other Way S7",
        "summary": "Their vacation connection became a full-time relocation. They confirmed a breakup at the season’s tell-all; rumors about subsequent partners are not included."
      },
      {
        "label": "The next chapter — announced",
        "era": "Hunt for Love S2",
        "summary": "TLC has announced a Puerto Rico return beginning October 5, 2026. No new partner or aired storyline is claimed."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "TV Insider: Chloe and Johny’s tell-all update",
        "url": "https://www.tvinsider.com/1242582/90-day-fiance-other-way-johny-fernandes-girlfriend-baby-rumors/"
      },
      {
        "label": "TLC: Hunt for Love season 2 singles (announced)",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-season-2-singles-bios-photos"
      }
    ]
  },
  {
    "personId": "p-johny-chloe-arc",
    "headline": "An Aruba tour guide whose vacation connection sailed into everyday relationship questions.",
    "bio": [
      "Johny worked as a pirate-boat tour guide when he met visiting American Chloe. Their holiday connection turned into The Other Way’s relocation story when she moved from Massachusetts to Aruba.",
      "His flirtatious public-facing work became a source of friction, alongside Chloe’s family concerns and questions about trust. The season ended with a confirmed breakup, proving that a sunny setting is not quite the same thing as smooth sailing."
    ],
    "originStory": "Johny’s relationship with vacationer Chloe and her decision to move to Aruba introduced him on The Other Way Season 7.",
    "journeys": [
      {
        "label": "Where it started: Johny & Chloe",
        "partnerName": "Chloe",
        "relationshipId": "ARC-5A3C5BB262AF",
        "era": "The Other Way S7",
        "summary": "The relationship began during her Aruba vacation. Their season-end breakup is documented; this profile leaves unsourced later-relationship rumors out."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "TV Insider: Chloe and Johny’s tell-all update",
        "url": "https://www.tvinsider.com/1242582/90-day-fiance-other-way-johny-fernandes-girlfriend-baby-rumors/"
      }
    ]
  },
  {
    "personId": "p-luke-madelein-arc",
    "headline": "A Colombia romance with wedding plans, business plans and some very important paperwork.",
    "bio": [
      "Luke met Madelein while visiting Colombia, and their relationship first appeared on Love in Paradise Season 4. Their return on The Other Way expanded the story from dating into relocation, elaborate wedding plans and questions about how to fund their future.",
      "They held a Colombian wedding ceremony, but Luke later clarified that they had not registered a legally binding marriage while pursuing a K-1 process. The celebration and the legal status are different chapters—here, the paperwork really does deserve its own seat at the table."
    ],
    "originStory": "Luke’s vacation meeting with Madelein introduced them on Love in Paradise Season 4. The Other Way Season 7 later followed his Colombia move and their wedding-and-visa plans.",
    "journeys": [
      {
        "label": "Where it started: Luke & Madelein",
        "partnerName": "Madelein",
        "relationshipId": "ARC-65D838BAA02F",
        "era": "Love in Paradise S4 · The Other Way S7",
        "summary": "Their Colombia relationship led to a wedding ceremony. Luke said in the February 2026 tell-all coverage that the marriage was not legally registered, so a ceremony must not be labeled a verified legal marriage."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "TV Insider: Luke and Madelein clarify their wedding and visa plans",
        "url": "https://www.tvinsider.com/swooon/1260821/90-day-fiance-luke-berry-madelein-perez-season-12-return/"
      }
    ]
  },
  {
    "personId": "p-madelein-luke-arc",
    "headline": "A Colombian love story where the wedding dresses and the legal documents told different tales.",
    "bio": [
      "Madelein met Luke during his visit to Colombia, bringing their relationship to Love in Paradise Season 4 before their later Other Way chapter. The returning couple planned a substantial wedding celebration while trying to build a shared future in Colombia.",
      "The ceremony was not a legally registered marriage, according to Luke’s subsequent explanation of their visa plans. Money pressures also sent him back to work in the United States: the romantic celebration was one milestone, not proof that every practical question had been settled."
    ],
    "originStory": "Madelein joined the franchise through her relationship with American visitor Luke on Love in Paradise Season 4; their Colombia move and wedding plans continued on The Other Way Season 7.",
    "journeys": [
      {
        "label": "Where it started: Madelein & Luke",
        "partnerName": "Luke",
        "relationshipId": "ARC-65D838BAA02F",
        "era": "Love in Paradise S4 · The Other Way S7",
        "summary": "They celebrated a Colombian ceremony while pursuing a K-1 process. February 2026 reporting of Luke’s explanation distinguishes the ceremony from a legally registered marriage."
      }
    ],
    "sources": [
      {
        "label": "TLC: The Other Way season 7 couples",
        "url": "https://www.tlc.com/shows/90-day-fiance-the-other-way/photo-galleries/90-day-fiance-the-other-way-season-6-couples-photos-bios"
      },
      {
        "label": "TV Insider: Luke and Madelein clarify their wedding and visa plans",
        "url": "https://www.tvinsider.com/swooon/1260821/90-day-fiance-luke-berry-madelein-perez-season-12-return/"
      }
    ]
  },
  {
    "personId": "p-cole-90-day-hunt-for-love-s1",
    "headline": "A commercial pilot whose resort romance encountered some relationship turbulence.",
    "bio": [
      "Cole joined Hunt for Love as a new single rather than one of the franchise’s returning stars. A commercial airline pilot, he connected with Jeniffer at the retreat and found himself competing with Rob for her attention.",
      "The season tracked a promising match through questions about exclusivity and what happened between Jeniffer and Rob. Cole’s story is a reminder that even someone comfortable with flight plans cannot schedule romantic certainty; the retreat connection is documented, but a present-day relationship is not freshly verified here."
    ],
    "originStory": "Cole entered Hunt for Love Season 1 as a retreat newcomer seeking a match. His connection with returning cast member Jeniffer became his principal televised relationship.",
    "journeys": [
      {
        "label": "Where it started: Cole & Jeniffer",
        "partnerName": "Jeniffer Tarazona",
        "relationshipId": "ARC-FD574218C9AC",
        "era": "Hunt for Love S1",
        "summary": "Their resort romance overlapped with Jeniffer’s interest in Rob. Post-retreat social-media activity is not treated as proof of a current relationship or breakup."
      }
    ],
    "sources": [
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "TV Insider: Cole and Jeniffer’s relationship history",
        "url": "https://www.tvinsider.com/swooon/1220773/90-day-hunt-for-love-jeniffer-cole-still-together-dating-updates/"
      },
      {
        "label": "TV Insider: Hunt for Love cast after the retreat",
        "url": "https://www.tvinsider.com/swooon/gallery/90-day-hunt-for-love-season-1-cast-where-are-they-now-updates/"
      }
    ]
  },
  {
    "personId": "p-mei-90-day-hunt-for-love-s1",
    "headline": "An energy reading and a stargazing date put this newcomer on Tim’s radar.",
    "bio": [
      "Mei arrived at Hunt for Love as one of the retreat’s new singles and connected with Tim late in the season. TLC’s recap highlights her energy reading for him, followed by a stargazing date—a considerably more memorable icebreaker than discussing the weather.",
      "Their brief connection ended before the finale, with disagreement over whether she should pursue Rob instead. Mei’s profile follows that documented retreat story; her surname, occupation and off-screen relationship life are not established by the sources used here."
    ],
    "originStory": "Mei joined Hunt for Love Season 1 as a newcomer looking for a romantic connection, and her featured match was with returning participant Tim.",
    "journeys": [
      {
        "label": "Where it started: Mei & Tim",
        "partnerName": "Tim Malcolm",
        "relationshipId": "ARC-1DEAE9E117B9",
        "era": "Hunt for Love S1",
        "summary": "Their late-season connection included stargazing, but ended before the finale. A suggested match with Rob was not a confirmed subsequent relationship."
      }
    ],
    "sources": [
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "TLC: Hunt for Love season recap",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/90-day-hunt-for-love-drama-recap"
      },
      {
        "label": "TV Insider: Hunt for Love season 1 couples",
        "url": "https://www.tvinsider.com/swooon/gallery/90-day-hunt-for-love-season-1-couples-still-together-relationship-updates/"
      }
    ]
  },
  {
    "personId": "p-rocky-90-day-hunt-for-love-s1",
    "headline": "A wellness-minded newcomer who traded the ukulele for some complicated heart-to-hearts.",
    "bio": [
      "Rocky joined Hunt for Love as a new single with a wellness-and-fitness background. His retreat connections included Chantel before a late-season date with Tiffany, giving this newcomer more than one route through the romance schedule.",
      "He and Tiffany left together but confirmed their split at the tell-all, while keeping contact around fitness. Rocky’s ukulele made an impression along the way; unfortunately, an instrument cannot harmonize every set of relationship expectations."
    ],
    "originStory": "Rocky entered Hunt for Love Season 1 among the retreat’s newcomers. He dated Chantel before forming his principal late-season connection with Tiffany.",
    "journeys": [
      {
        "label": "An early retreat connection",
        "partnerName": "Chantel Everett",
        "era": "Hunt for Love S1",
        "summary": "Rocky connected with Chantel earlier in the retreat; this was not an established off-screen partnership."
      },
      {
        "label": "The later retreat match: Rocky & Tiffany",
        "partnerName": "Tiffany Franco",
        "relationshipId": "ARC-64DAE29CF987",
        "era": "Hunt for Love S1",
        "summary": "They left the retreat together and reported a breakup at the tell-all, while remaining in touch about fitness."
      }
    ],
    "sources": [
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "TV Insider: Rocky and Tiffany’s retreat relationship",
        "url": "https://www.tvinsider.com/swooon/1218724/90-day-hunt-for-love-tiffany-rocky-still-together-ronald-relationship-updates/"
      },
      {
        "label": "TV Insider: Hunt for Love cast after the retreat",
        "url": "https://www.tvinsider.com/swooon/gallery/90-day-hunt-for-love-season-1-cast-where-are-they-now-updates/"
      }
    ]
  },
  {
    "personId": "p-jay-90-day-hunt-for-love-s1",
    "headline": "A Louisiana newcomer whose Tiffany date brought humor to a busy resort courtship.",
    "bio": [
      "Jay was introduced as a 28-year-old from Shreveport, Louisiana, when he joined Hunt for Love’s first retreat. His featured date with Tiffany arrived while Carlo was also interested in her, so the conversation had a little more competition than an ordinary first date.",
      "Tiffany enjoyed Jay’s humor, and he admired the way she presented herself. Their date is the documented chapter here—not evidence of a lasting partnership—making this a promising introduction rather than a relationship status to fill in by guesswork."
    ],
    "originStory": "Jay entered Hunt for Love Season 1 as a new retreat single. A date with returning cast member Tiffany supplied his documented romantic storyline.",
    "journeys": [
      {
        "label": "The featured retreat date",
        "partnerName": "Tiffany Franco",
        "era": "Hunt for Love S1",
        "summary": "Jay and Tiffany explored a date during the retreat. A lasting relationship or later partner is not established by the available recap."
      }
    ],
    "sources": [
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "Reality TV World: Jay and Tiffany’s date",
        "url": "https://www.realitytvworld.com/news/90-day-hunt-for-love-carlo-picks-elise-over-tiffany-rob-calls-jeniffer-the-one-tim-asks-mei-out-35247.php"
      }
    ]
  },
  {
    "personId": "p-joe-90-day-hunt-for-love-s1",
    "headline": "A first-retreat newcomer whose Chantel date put butterflies on the itinerary.",
    "bio": [
      "Joe entered Hunt for Love as one of its new singles and asked Chantel on a date. Their conversation addressed his younger age, with Joe making clear that the difference did not trouble him.",
      "Their date included a beer bath and a kiss, giving a new connection a rather unusual setting. Chantel enjoyed his company, but a promising resort date is not proof of a lasting partnership; that distinction matters more than how picturesque the bubbles looked."
    ],
    "originStory": "Joe joined Hunt for Love Season 1 as a new retreat participant, and his date with returning cast member Chantel became his documented romantic chapter.",
    "journeys": [
      {
        "label": "The featured retreat connection",
        "partnerName": "Chantel Everett",
        "era": "Hunt for Love S1",
        "summary": "Joe and Chantel explored mutual attraction on a retreat date. No established post-retreat partnership or later partner is verified here."
      }
    ],
    "sources": [
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "Extra: Joe asks Chantel on a retreat date",
        "url": "https://extratv.com/2025/06/26/90-day-hunt-for-love-chantel-has-butterflies-after-getting-asked-on-date-exclusive-clip/"
      },
      {
        "label": "Reality TV World: Joe, Chantel, Nikki and Usman’s retreat dates",
        "url": "https://www.realitytvworld.com/news/90-day-hunt-for-love-usman-begs-cortney-pick-him-jeniffer-defends-love-triangle-and-chantel-has-crush-35159a.php"
      }
    ]
  },
  {
    "personId": "p-nikki-90-day-hunt-for-love-s1",
    "headline": "An animal-loving retreat newcomer who kept the compatibility conversation direct.",
    "bio": [
      "Nikki joined Hunt for Love as one of the new singles and went on a date with Usman. Their spiritual-ritual activity gave way to a hot-tub conversation about what each wanted from a partner.",
      "She appreciated his support during the activity, but their relationship expectations did not align. Nikki was comfortable with continuing to meet other people, giving this date a clear ending rather than trying to turn every enjoyable afternoon into an engagement announcement."
    ],
    "originStory": "Nikki entered Hunt for Love Season 1 as a newcomer seeking a match; her documented featured date was with returning participant Usman.",
    "journeys": [
      {
        "label": "The featured retreat date",
        "partnerName": "Usman Umar",
        "era": "Hunt for Love S1",
        "summary": "An activity date led to a compatibility conversation. They discussed moving on to other possibilities rather than establishing a lasting couple."
      }
    ],
    "sources": [
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "Reality TV World: Joe, Chantel, Nikki and Usman’s retreat dates",
        "url": "https://www.realitytvworld.com/news/90-day-hunt-for-love-usman-begs-cortney-pick-him-jeniffer-defends-love-triangle-and-chantel-has-crush-35159a.php"
      }
    ]
  },
  {
    "personId": "p-kassidy-90-day-hunt-for-love-s1",
    "headline": "A retreat newcomer who turned a flirtation into an impromptu songwriting request.",
    "bio": [
      "Kassidy arrived at Hunt for Love among the new singles meeting the franchise’s returning cast. Her on-camera interaction with Usman featured his musical introduction, followed by her request for a song about her.",
      "That moment made their flirtation memorable without establishing a committed relationship. A custom chorus is a creative icebreaker, but this profile does not award it the same status as an engagement ring; Kassidy’s other romantic chapters and personal background still need better sources."
    ],
    "originStory": "Kassidy joined Hunt for Love Season 1 as a new retreat single. Her documented interaction with Usman centered on his singing and her request for an improvised song.",
    "journeys": [
      {
        "label": "The documented retreat flirtation",
        "partnerName": "Usman Umar",
        "era": "Hunt for Love S1",
        "summary": "Kassidy and Usman shared a musical flirtation. The footage does not establish an ongoing couple or a post-retreat partner."
      }
    ],
    "sources": [
      {
        "label": "TLC: Hunt for Love’s new singles",
        "url": "https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls"
      },
      {
        "label": "Us Weekly: Kassidy’s musical flirtation with Usman",
        "url": "https://www.usmagazine.com/entertainment/news/90-day-hunt-for-love-sneak-peek-cortney-reacts-to-usmans-flirting/"
      }
    ]
  }
]

export const researchedTimelinesC: Record<string, CastProfileTimeline> = {
  "p-tim-malcolm": {
    "connections": [
      {
        "name": "Jeniffer Tarazona",
        "personId": "p-jeniffer-tarazona",
        "context": "The online girlfriend behind his first televised romance.",
        "relationshipId": "ARC-5E9901D5F3A9"
      },
      {
        "name": "Veronica Rodriguez",
        "personId": "p-veronica-rodriguez",
        "context": "Ex-fiancée, longtime friend and familiar franchise companion."
      },
      {
        "name": "Luisa",
        "context": "His Single Life season 4 date; no unverified cast-page identifier is assigned."
      },
      {
        "name": "Mei",
        "personId": "p-mei-90-day-hunt-for-love-s1",
        "context": "A later connection at the Tulum retreat.",
        "relationshipId": "ARC-1DEAE9E117B9"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 3,
        "title": "An online match meets real life",
        "recap": "Tim visited Jeniffer in Colombia, where affection and his relationship with Veronica became sticking points. The trip did not produce a lasting romance.",
        "partnerPersonIds": [
          "p-jeniffer-tarazona"
        ],
        "relationshipId": "ARC-5E9901D5F3A9"
      },
      {
        "show": "90 Day: The Single Life",
        "season": 4,
        "title": "Dating with the best friend nearby",
        "recap": "Tim pursued Luisa while Veronica dated Jamal. New relationships repeatedly collided with the exes’ enduring friendship."
      },
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "A resort with a familiar ex",
        "recap": "Tim encountered Jeniffer again and later went stargazing with Mei. Their new connection ended before the retreat finale.",
        "partnerPersonIds": [
          "p-mei-90-day-hunt-for-love-s1"
        ],
        "relationshipId": "ARC-1DEAE9E117B9"
      }
    ]
  },
  "p-veronica-rodriguez": {
    "connections": [
      {
        "name": "Tim Malcolm",
        "personId": "p-tim-malcolm",
        "context": "Former fiancé and close friend who introduced her to the franchise."
      },
      {
        "name": "Jamal Menzies",
        "personId": "p-jamal-menzies",
        "context": "Her later Single Life partner.",
        "relationshipId": "ARC-5AFE8D244E96"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 3,
        "title": "The ex everyone needed to meet",
        "recap": "Veronica’s close friendship with Tim became part of his visit to Jeniffer, including their video introduction. This was a supporting role, not her own international couple storyline.",
        "partnerPersonIds": [
          "p-tim-malcolm"
        ]
      },
      {
        "show": "90 Day: The Single Life",
        "season": 3,
        "title": "Her own dating reset",
        "recap": "Veronica stepped into the dating spotlight, hoping to find someone comfortable with both motherhood and her friendship with Tim."
      },
      {
        "show": "90 Day: The Single Life",
        "season": 4,
        "title": "Long distance and short replies",
        "recap": "Veronica and Jamal tried an exclusive relationship between Charlotte and San Diego. They confirmed a breakup at the tell-all after clashing over communication.",
        "partnerPersonIds": [
          "p-jamal-menzies"
        ],
        "relationshipId": "ARC-5AFE8D244E96"
      }
    ]
  },
  "p-jamal-menzies": {
    "connections": [
      {
        "name": "Kim Menzies",
        "personId": "p-kim-menzies",
        "context": "His mother and the connection that first brought him into the franchise."
      },
      {
        "name": "Veronica Rodriguez",
        "personId": "p-veronica-rodriguez",
        "context": "His featured Single Life romance.",
        "relationshipId": "ARC-5AFE8D244E96"
      }
    ],
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 4,
        "title": "A crossover relationship gets serious",
        "recap": "Jamal and Veronica became exclusive but disagreed about communication and Tim’s role. Their tell-all appearance confirmed that the romance had ended.",
        "partnerPersonIds": [
          "p-veronica-rodriguez"
        ],
        "relationshipId": "ARC-5AFE8D244E96"
      },
      {
        "show": "90 Day: Hunt for Love",
        "season": 2,
        "title": "A new romantic search — announced",
        "recap": "TLC announced Jamal’s Puerto Rico return with hopes for an old-fashioned romance. The October 5, 2026 premiere is still upcoming as of this profile’s research date.",
        "status": "announced"
      }
    ]
  },
  "p-john-mcmanus": {
    "connections": [
      {
        "name": "Patrick Mendes",
        "personId": "p-patrick-mendes",
        "context": "His brother and original connection to the franchise."
      },
      {
        "name": "Thaís Ramone",
        "personId": "p-thais-ramone",
        "context": "His sister-in-law in the original family storyline."
      },
      {
        "name": "Meghan Brown",
        "personId": "p-meghan-brown-john-mcmanus-arc",
        "context": "The partner behind his own dating storyline.",
        "relationshipId": "ARC-F4456ED9F934"
      }
    ],
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 4,
        "title": "From bachelor life to Texas",
        "recap": "John moved to be with Meghan and navigated commitment and becoming a parental figure to her daughter. Patrick questioned the pace as the relationship moved toward a proposal.",
        "partnerPersonIds": [
          "p-meghan-brown-john-mcmanus-arc"
        ],
        "relationshipId": "ARC-F4456ED9F934"
      }
    ]
  },
  "p-meghan-brown-john-mcmanus-arc": {
    "connections": [
      {
        "name": "John McManus",
        "personId": "p-john-mcmanus",
        "context": "Her featured partner and Rowan’s father.",
        "relationshipId": "ARC-F4456ED9F934"
      }
    ],
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 4,
        "title": "Making room for a family",
        "recap": "Meghan pressed John for a clear commitment as he adjusted to life in Texas with her and her daughter. Family opinions and differing expectations kept their plans under discussion.",
        "partnerPersonIds": [
          "p-john-mcmanus"
        ],
        "relationshipId": "ARC-F4456ED9F934"
      }
    ]
  },
  "p-debbie-johnson": {
    "connections": [
      {
        "name": "Colt Johnson",
        "personId": "p-colt-johnson",
        "context": "Her son and original franchise connection."
      },
      {
        "name": "Vanessa Guerra",
        "personId": "p-vanessa-guerra-colt-arc",
        "context": "Colt’s former partner in the family storyline."
      },
      {
        "name": "Tony",
        "context": "Her Canadian partner during The Single Life season 3."
      }
    ],
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 2,
        "title": "Stepping back into dating",
        "recap": "Debbie joined the dating world while Colt and Vanessa wanted more independence. The change challenged both her romantic confidence and the family’s familiar living arrangement."
      },
      {
        "show": "90 Day: The Single Life",
        "season": 3,
        "title": "A new relationship in Canada",
        "recap": "Debbie connected with Tony and chose to move to Vancouver. Introducing him to Colt became another important step in her new chapter."
      },
      {
        "show": "90 Day: The Single Life",
        "season": 5,
        "title": "A family visit, not a new dating season",
        "recap": "TLC’s recap documents Debbie visiting Cortney to advocate for Colt. This is a supporting appearance, not a new featured romance for Debbie."
      }
    ]
  },
  "p-fernanda-flores": {
    "connections": [
      {
        "name": "Jonathan Rivera",
        "personId": "p-jonathan-rivera",
        "context": "Her original fiancé and former husband.",
        "relationshipId": "ARC-1A6AC0C11EFF"
      },
      {
        "name": "Robby",
        "context": "A gym acquaintance featured during her Single Life dating reset."
      },
      {
        "name": "Noel Mikaelian",
        "context": "The boxer she later dated after meeting in Miami; present-day status is not confirmed here."
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé",
        "season": 6,
        "title": "Mexico to the wedding countdown",
        "recap": "Fernanda and Jonathan’s vacation connection became an engagement and U.S. wedding. Adjusting to their shared life brought disagreements about their future.",
        "partnerPersonIds": [
          "p-jonathan-rivera"
        ],
        "relationshipId": "ARC-1A6AC0C11EFF"
      },
      {
        "show": "90 Day: The Single Life",
        "season": 1,
        "title": "Dating after divorce",
        "recap": "Fernanda tried to move forward with Robby while news of Jonathan’s new engagement stirred old feelings. Her later Miami chapter introduced Noel."
      }
    ]
  },
  "p-brittany-banks": {
    "connections": [
      {
        "name": "Yazan Abo Horira",
        "personId": "p-yazan-abo-horira",
        "context": "The partner behind her original Jordan storyline.",
        "relationshipId": "ARC-97EBA9D0AEA9"
      },
      {
        "name": "Terence",
        "context": "A later date introduced through a mutual friend."
      },
      {
        "name": "Justin",
        "context": "Another connection explored during The Single Life."
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 2,
        "title": "Different visions in Jordan",
        "recap": "Brittany pursued life with Yazan in Jordan while their expectations about religion, family and independence conflicted.",
        "partnerPersonIds": [
          "p-yazan-abo-horira"
        ],
        "relationshipId": "ARC-97EBA9D0AEA9"
      },
      {
        "show": "90 Day: The Single Life",
        "season": 1,
        "title": "Comparing new connections",
        "recap": "Brittany dated Terence while also considering Justin. She worked out what she wanted from a new relationship after the Yazan chapter."
      },
      {
        "show": "90 Day: Hunt for Love",
        "season": 2,
        "title": "A Puerto Rico dating reset — announced",
        "recap": "TLC announced Brittany’s return for the October 5, 2026 premiere, open to dating men or women. This is an announced season, not a recap of episodes already aired.",
        "status": "announced"
      }
    ]
  },
  "p-caesar-mack": {
    "connections": [
      {
        "name": "Maria",
        "personId": "p-maria-caesar-arc",
        "context": "The Ukrainian online girlfriend behind his franchise introduction.",
        "relationshipId": "ARC-8B35A0FBCB33"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 3,
        "title": "A meeting that did not happen",
        "recap": "Caesar planned to meet Maria in Mexico, but the reservation failed and the trip did not deliver the reunion he expected. Their online relationship became a central question of the season.",
        "partnerPersonIds": [
          "p-maria-caesar-arc"
        ],
        "relationshipId": "ARC-8B35A0FBCB33"
      },
      {
        "show": "90 Day: The Single Life",
        "season": 3,
        "title": "Trying professional matchmaking",
        "recap": "Caesar traveled to Kyiv for help finding a partner after his earlier online relationship. The season followed a different approach to meeting women face to face."
      }
    ]
  },
  "p-corey-rathgeber": {
    "connections": [
      {
        "name": "Evelin Villegas",
        "personId": "p-evelin-villegas",
        "context": "His original partner in Ecuador.",
        "relationshipId": "ARC-E196BA6D9016"
      },
      {
        "name": "Jenny",
        "context": "The woman Corey dated during time apart; no separate indexed identity is asserted."
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 1,
        "title": "Choosing Ecuador",
        "recap": "Corey moved to be with Evelin, adjusted to her community and helped build a beach-bar business. Their first season included his proposal.",
        "partnerPersonIds": [
          "p-evelin-villegas"
        ],
        "relationshipId": "ARC-E196BA6D9016"
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3,
        "title": "A wedding with history attached",
        "recap": "Corey and Evelin planned a ceremony while revealing they had already married privately. His relationship with Jenny surfaced as they tried to rebuild trust.",
        "partnerPersonIds": [
          "p-evelin-villegas"
        ],
        "relationshipId": "ARC-E196BA6D9016"
      }
    ]
  },
  "p-evelin-villegas": {
    "connections": [
      {
        "name": "Corey Rathgeber",
        "personId": "p-corey-rathgeber",
        "context": "The partner behind her original Other Way story.",
        "relationshipId": "ARC-E196BA6D9016"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 1,
        "title": "Home in Ecuador",
        "recap": "Evelin and Corey adjusted to living in her community and operating a beach bar. Their differing expectations about marriage shaped the first chapter.",
        "partnerPersonIds": [
          "p-corey-rathgeber"
        ],
        "relationshipId": "ARC-E196BA6D9016"
      },
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3,
        "title": "The secret behind the wedding plans",
        "recap": "Evelin told her family she and Corey had already married. His relationship with Jenny during their time apart complicated their plans and prompted counseling.",
        "partnerPersonIds": [
          "p-corey-rathgeber"
        ],
        "relationshipId": "ARC-E196BA6D9016"
      }
    ]
  },
  "p-steven-johnston": {
    "connections": [
      {
        "name": "Alina Shaimardanova",
        "personId": "p-alina-shaimardanova",
        "context": "His Russian partner in the Turkey marriage chapter.",
        "relationshipId": "ARC-0B785EDADA04"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3,
        "title": "A wedding plan in Turkey",
        "recap": "Steven and Alina navigated religious expectations and revelations about his past before he proposed. They married in Turkey, while plans for their next country still required work.",
        "partnerPersonIds": [
          "p-alina-shaimardanova"
        ],
        "relationshipId": "ARC-0B785EDADA04"
      }
    ]
  },
  "p-alina-shaimardanova": {
    "connections": [
      {
        "name": "Steven Johnston",
        "personId": "p-steven-johnston",
        "context": "Her Utah partner in their first televised romance.",
        "relationshipId": "ARC-0B785EDADA04"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3,
        "title": "Love, trust and Turkey",
        "recap": "Alina questioned Steven’s honesty and contact with other women while considering the expectations of his faith. She accepted his proposal and the couple married in Turkey.",
        "partnerPersonIds": [
          "p-steven-johnston"
        ],
        "relationshipId": "ARC-0B785EDADA04"
      }
    ]
  },
  "p-ellie-rose": {
    "connections": [
      {
        "name": "Victor McLean",
        "personId": "p-victor-mclean",
        "context": "Her partner from Providencia.",
        "relationshipId": "ARC-9A663F14F339"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3,
        "title": "A reunion after the storm",
        "recap": "Ellie traveled to Colombia fearing for Victor after a hurricane devastated Providencia. Their reunion led to rebuilding plans alongside unresolved trust and financial questions.",
        "partnerPersonIds": [
          "p-victor-mclean"
        ],
        "relationshipId": "ARC-9A663F14F339"
      }
    ]
  },
  "p-victor-mclean": {
    "connections": [
      {
        "name": "Ellie Rose",
        "personId": "p-ellie-rose",
        "context": "The Seattle partner who planned to move to Providencia.",
        "relationshipId": "ARC-9A663F14F339"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 3,
        "title": "Survival, reunion and rebuilding",
        "recap": "Victor reunited with Ellie after surviving the hurricane that struck Providencia. They considered how to rebuild while working through earlier relationship problems.",
        "partnerPersonIds": [
          "p-ellie-rose"
        ],
        "relationshipId": "ARC-9A663F14F339"
      }
    ]
  },
  "p-stephanie-matto": {
    "connections": [
      {
        "name": "Erika Owens",
        "personId": "p-erika-owens",
        "context": "The original online partner she traveled to Australia to meet.",
        "relationshipId": "ARC-E80C906E26A4"
      },
      {
        "name": "Dave",
        "context": "A dating-app connection during The Single Life."
      },
      {
        "name": "Steph",
        "context": "Her hairdresser and a later dating interest."
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: Before the 90 Days",
        "season": 4,
        "title": "Meeting Erika in Australia",
        "recap": "Stephanie and Erika met in person after a year of long-distance contact. Disagreements about intimacy, friends and disclosure to family contributed to their breakup.",
        "partnerPersonIds": [
          "p-erika-owens"
        ],
        "relationshipId": "ARC-E80C906E26A4"
      },
      {
        "show": "90 Day: The Single Life",
        "season": 2,
        "title": "A return to the dating pool",
        "recap": "Stephanie began dating again after a period of celibacy. Dates with Dave and Steph helped her explore what she wanted from a new connection."
      }
    ]
  },
  "p-kelly-brown": {
    "connections": [
      {
        "name": "Molly Hopkins",
        "personId": "p-molly-hopkins",
        "context": "The partner who introduced him to the franchise.",
        "relationshipId": "ARC-360783C5EC56"
      }
    ],
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 1,
        "title": "Meeting Molly in Georgia",
        "recap": "Kelly traveled from New York to spend time with Molly. She weighed their chemistry alongside his place in her family.",
        "partnerPersonIds": [
          "p-molly-hopkins"
        ],
        "relationshipId": "ARC-360783C5EC56"
      },
      {
        "show": "90 Day: The Last Resort",
        "season": 1,
        "title": "A final attempt at reconnection",
        "recap": "Kelly and Molly entered the retreat with their relationship already in trouble. After therapy failed to bring progress, they agreed to end it and Kelly departed.",
        "partnerPersonIds": [
          "p-molly-hopkins"
        ],
        "relationshipId": "ARC-360783C5EC56"
      }
    ]
  },
  "p-vanessa-guerra-colt-arc": {
    "connections": [
      {
        "name": "Colt Johnson",
        "personId": "p-colt-johnson",
        "context": "Her friend, eventual husband and former partner.",
        "relationshipId": "ARC-41C27194D3BC"
      }
    ],
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 1,
        "title": "From friendship to a proposal",
        "recap": "Vanessa questioned whether she could trust Colt after his past relationships. They tried dating seriously, and she accepted his proposal with reservations.",
        "partnerPersonIds": [
          "p-colt-johnson"
        ],
        "relationshipId": "ARC-41C27194D3BC"
      }
    ]
  },
  "p-giannis-chantel-arc": {
    "connections": [
      {
        "name": "Chantel Everett",
        "personId": "p-chantel-everett",
        "context": "The visiting cast member behind his televised dating chapter.",
        "relationshipId": "ARC-1B2F99EAC8E9"
      }
    ],
    "seasons": [
      {
        "show": "90 Day: The Single Life",
        "season": 4,
        "title": "A connection in Crete",
        "recap": "Giannis and Chantel explored a vacation romance, going on dates and talking about family involvement and the possibility of a future in Greece.",
        "partnerPersonIds": [
          "p-chantel-everett"
        ],
        "relationshipId": "ARC-1B2F99EAC8E9"
      }
    ]
  },
  "p-nicole-sherbiny": {
    "connections": [
      {
        "name": "Mahmoud El Sherbiny",
        "personId": "p-mahmoud-el-sherbiny",
        "context": "Her husband in their Egypt-to-Los Angeles storyline.",
        "relationshipId": "ARC-2374C52AC619"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 4,
        "title": "Married life in Egypt",
        "recap": "Nicole returned to Egypt to live with Mahmoud. Clothing, faith and family expectations made adjusting to their shared home more complicated than unpacking a suitcase.",
        "partnerPersonIds": [
          "p-mahmoud-el-sherbiny"
        ],
        "relationshipId": "ARC-2374C52AC619"
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 8,
        "title": "The Los Angeles reversal",
        "recap": "Mahmoud joined Nicole in Los Angeles after her difficult time in Egypt. The move reversed who was far from home, while their cultural disagreements remained central.",
        "partnerPersonIds": [
          "p-mahmoud-el-sherbiny"
        ],
        "relationshipId": "ARC-2374C52AC619"
      }
    ]
  },
  "p-mahmoud-el-sherbiny": {
    "connections": [
      {
        "name": "Nicole Sherbiny",
        "personId": "p-nicole-sherbiny",
        "context": "His spouse in their original cross-cultural marriage.",
        "relationshipId": "ARC-2374C52AC619"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 4,
        "title": "An Egyptian home, different expectations",
        "recap": "Mahmoud and Nicole tried married life together in Egypt. His religious and family expectations collided with her ideas about independence and clothing.",
        "partnerPersonIds": [
          "p-nicole-sherbiny"
        ],
        "relationshipId": "ARC-2374C52AC619"
      },
      {
        "show": "90 Day Fiancé: Happily Ever After?",
        "season": 8,
        "title": "A new home in Los Angeles",
        "recap": "Mahmoud moved to the United States to join Nicole. Adapting to her world did not automatically resolve the differences their Egypt chapter had exposed.",
        "partnerPersonIds": [
          "p-nicole-sherbiny"
        ],
        "relationshipId": "ARC-2374C52AC619"
      }
    ]
  },
  "p-corona-blakey": {
    "connections": [
      {
        "name": "Ingi Hilmar",
        "personId": "p-ingi-hilmar",
        "context": "The Icelandic partner behind her move.",
        "relationshipId": "ARC-65C0C2DD941E"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 6,
        "title": "Love versus the life plan",
        "recap": "Corona moved to Iceland after setting aside a prestigious midwifery-training opportunity. Different expectations about commitment and obstacles to continuing her studies complicated the relocation.",
        "partnerPersonIds": [
          "p-ingi-hilmar"
        ],
        "relationshipId": "ARC-65C0C2DD941E"
      }
    ]
  },
  "p-ingi-hilmar": {
    "connections": [
      {
        "name": "Corona Blakey",
        "personId": "p-corona-blakey",
        "context": "The American partner who moved to Iceland.",
        "relationshipId": "ARC-65C0C2DD941E"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 6,
        "title": "Making room for a bigger commitment",
        "recap": "Corona arrived in Iceland expecting a future with Ingi. Her ambitions and their differing ideas about commitment challenged a relationship that had begun during a visit.",
        "partnerPersonIds": [
          "p-corona-blakey"
        ],
        "relationshipId": "ARC-65C0C2DD941E"
      }
    ]
  },
  "p-joanne-digesu": {
    "connections": [
      {
        "name": "Sean",
        "personId": "p-sean-tow-s6",
        "context": "Her Irish husband in the family-and-relocation storyline.",
        "relationshipId": "ARC-8E692C75457B"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 6,
        "title": "The marriage everyone had to catch up on",
        "recap": "Joanne brought her sons to Ireland and disclosed her marriage to Sean. Their hurt over the secret and questions about her proposed move made family trust the central issue.",
        "partnerPersonIds": [
          "p-sean-tow-s6"
        ],
        "relationshipId": "ARC-8E692C75457B"
      }
    ]
  },
  "p-sean-tow-s6": {
    "connections": [
      {
        "name": "Joanne DiGesu",
        "personId": "p-joanne-digesu",
        "context": "His wife, whose sons learned about their marriage during the Ireland visit.",
        "relationshipId": "ARC-8E692C75457B"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 6,
        "title": "A wedding secret meets the family",
        "recap": "Sean and Joanne revealed their marriage to her sons during an Ireland visit. He acknowledged their hurt as the couple considered how a cross-Atlantic family arrangement could work.",
        "partnerPersonIds": [
          "p-joanne-digesu"
        ],
        "relationshipId": "ARC-8E692C75457B"
      }
    ]
  },
  "p-josh-mcguffey": {
    "connections": [
      {
        "name": "Lily Huang",
        "personId": "p-lily-huang",
        "context": "His Chinese spouse and original language-app match.",
        "relationshipId": "ARC-1D15E984ED3C"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 6,
        "title": "A shared home and an uneven budget",
        "recap": "Josh moved to China after leaving his American job, while Lily supported the household. Money, appreciation and their wedding celebration brought disagreements into the open, with his brother helping mediate.",
        "partnerPersonIds": [
          "p-lily-huang"
        ],
        "relationshipId": "ARC-1D15E984ED3C"
      }
    ]
  },
  "p-lily-huang": {
    "connections": [
      {
        "name": "Josh McGuffey",
        "personId": "p-josh-mcguffey",
        "context": "Her American husband and language-app match.",
        "relationshipId": "ARC-1D15E984ED3C"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 6,
        "title": "Love, work and feeling appreciated",
        "recap": "Lily financed their shared life while Josh settled into China. Their disagreements about money and affection continued into preparations for a wedding celebration, prompting family mediation.",
        "partnerPersonIds": [
          "p-josh-mcguffey"
        ],
        "relationshipId": "ARC-1D15E984ED3C"
      }
    ]
  },
  "p-greta-matthew-arc": {
    "connections": [
      {
        "name": "Matthew",
        "personId": "p-matthew-greta-arc",
        "context": "Her original English partner from the vegan dating app.",
        "relationshipId": "ARC-195717FD4F4B"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "Compatible profiles, complicated reality",
        "recap": "Greta joined Matthew in England and stayed with him and his parents. Differences about their future and emotional connection led to a breakup rather than the permanent move-in they had imagined.",
        "partnerPersonIds": [
          "p-matthew-greta-arc"
        ],
        "relationshipId": "ARC-195717FD4F4B"
      }
    ]
  },
  "p-matthew-greta-arc": {
    "connections": [
      {
        "name": "Greta",
        "personId": "p-greta-matthew-arc",
        "context": "The Oklahoma partner who traveled to join him.",
        "relationshipId": "ARC-195717FD4F4B"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "An arrival that changed the plan",
        "recap": "Matthew welcomed Greta into life with his parents in England. Their disagreements about compatibility and the future surfaced quickly, and the relationship ended during the visit.",
        "partnerPersonIds": [
          "p-greta-matthew-arc"
        ],
        "relationshipId": "ARC-195717FD4F4B"
      }
    ]
  },
  "p-anthony-manon-arc": {
    "connections": [
      {
        "name": "Manon",
        "personId": "p-manon-anthony-arc",
        "context": "His French wife and fellow parent in their relocation story.",
        "relationshipId": "ARC-7C656AE6A109"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "A family reset in France",
        "recap": "Anthony and Manon moved from California to France with their young son, hoping to improve their marriage. Finances, close quarters and family expectations complicated the fresh start.",
        "partnerPersonIds": [
          "p-manon-anthony-arc"
        ],
        "relationshipId": "ARC-7C656AE6A109"
      }
    ]
  },
  "p-manon-anthony-arc": {
    "connections": [
      {
        "name": "Anthony",
        "personId": "p-anthony-manon-arc",
        "context": "Her American husband and Benjamin’s father.",
        "relationshipId": "ARC-7C656AE6A109"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "Home country, new pressures",
        "recap": "Manon brought Anthony and their son to France after struggling with their California family routine. The couple’s plans had to contend with money worries, relatives and limited personal space.",
        "partnerPersonIds": [
          "p-anthony-manon-arc"
        ],
        "relationshipId": "ARC-7C656AE6A109"
      }
    ]
  },
  "p-pattiya-dylan-arc": {
    "connections": [
      {
        "name": "Dylan",
        "personId": "p-dylan-pattiya-arc",
        "context": "Her longtime Australian boyfriend.",
        "relationshipId": "ARC-D3D9F5B27934"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "Long distance becomes next door",
        "recap": "Pattiya moved to Tasmania after years of an on-and-off relationship with Dylan. Trust, their age gap and his mother living nearby complicated the transition to sharing daily life.",
        "partnerPersonIds": [
          "p-dylan-pattiya-arc"
        ],
        "relationshipId": "ARC-D3D9F5B27934"
      }
    ]
  },
  "p-dylan-pattiya-arc": {
    "connections": [
      {
        "name": "Pattiya",
        "personId": "p-pattiya-dylan-arc",
        "context": "His longtime American girlfriend, who moved to Tasmania.",
        "relationshipId": "ARC-D3D9F5B27934"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "A familiar relationship, unfamiliar routine",
        "recap": "Dylan and Pattiya tried to replace years of intermittent long-distance dating with life together in Tasmania. Trust concerns and nearby family made the adjustment more involved than simply moving her luggage in.",
        "partnerPersonIds": [
          "p-pattiya-dylan-arc"
        ],
        "relationshipId": "ARC-D3D9F5B27934"
      }
    ]
  },
  "p-chloe": {
    "connections": [
      {
        "name": "Johny",
        "personId": "p-johny-chloe-arc",
        "context": "The Aruba tour guide behind her original televised romance.",
        "relationshipId": "ARC-5A3C5BB262AF"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "The holiday romance gets a home address",
        "recap": "Chloe relocated to Aruba to be with Johny, facing trust concerns and skepticism from her family. Their tell-all update confirmed that the relationship had ended.",
        "partnerPersonIds": [
          "p-johny-chloe-arc"
        ],
        "relationshipId": "ARC-5A3C5BB262AF"
      },
      {
        "show": "90 Day: Hunt for Love",
        "season": 2,
        "title": "After Aruba, a new setting — announced",
        "recap": "TLC announced Chloe among the singles heading to Puerto Rico after her Aruba relationship ended. No new partner or episode outcome is established by the casting announcement.",
        "status": "announced"
      }
    ]
  },
  "p-johny-chloe-arc": {
    "connections": [
      {
        "name": "Chloe",
        "personId": "p-chloe",
        "context": "His American partner who moved to Aruba.",
        "relationshipId": "ARC-5A3C5BB262AF"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "From boat-tour meeting to a shared life",
        "recap": "Johny and Chloe tried to make their vacation-born relationship work full time in Aruba. Trust conflicts and family doubts followed them, and they confirmed their split at the tell-all.",
        "partnerPersonIds": [
          "p-chloe"
        ],
        "relationshipId": "ARC-5A3C5BB262AF"
      }
    ]
  },
  "p-luke-madelein-arc": {
    "connections": [
      {
        "name": "Madelein",
        "personId": "p-madelein-luke-arc",
        "context": "His original Colombian partner, with whom he held a wedding ceremony.",
        "relationshipId": "ARC-65D838BAA02F"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "A wedding, a business plan and a visa",
        "recap": "Luke moved to Colombia and planned a lavish ceremony with Madelein while facing financial pressure. At the tell-all, he explained their unregistered ceremony and K-1 plans, and described returning to the United States to earn money.",
        "partnerPersonIds": [
          "p-madelein-luke-arc"
        ],
        "relationshipId": "ARC-65D838BAA02F"
      }
    ]
  },
  "p-madelein-luke-arc": {
    "connections": [
      {
        "name": "Luke",
        "personId": "p-luke-madelein-arc",
        "context": "Her original American partner and wedding-ceremony partner.",
        "relationshipId": "ARC-65D838BAA02F"
      }
    ],
    "seasons": [
      {
        "show": "90 Day Fiancé: The Other Way",
        "season": 7,
        "title": "Celebration meets practical planning",
        "recap": "Madelein and Luke planned their Colombia wedding while navigating trust and money concerns. Their tell-all chapter clarified that the ceremony was not legally registered and that Luke had returned to the United States for work.",
        "partnerPersonIds": [
          "p-luke-madelein-arc"
        ],
        "relationshipId": "ARC-65D838BAA02F"
      }
    ]
  },
  "p-cole-90-day-hunt-for-love-s1": {
    "connections": [
      {
        "name": "Jeniffer Tarazona",
        "personId": "p-jeniffer-tarazona",
        "context": "The returning cast member he dated at the retreat.",
        "relationshipId": "ARC-FD574218C9AC"
      },
      {
        "name": "Rob Warne",
        "personId": "p-rob-warne",
        "context": "A fellow retreat participant and rival for Jeniffer’s attention, not Cole’s romantic partner."
      }
    ],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "A resort triangle takes shape",
        "recap": "Cole connected with Jeniffer, while her interest in Rob complicated the match. Questions about trust and exclusivity followed the couple through their retreat chapter.",
        "partnerPersonIds": [
          "p-jeniffer-tarazona"
        ],
        "relationshipId": "ARC-FD574218C9AC"
      }
    ]
  },
  "p-mei-90-day-hunt-for-love-s1": {
    "connections": [
      {
        "name": "Tim Malcolm",
        "personId": "p-tim-malcolm",
        "context": "Her brief late-season retreat connection.",
        "relationshipId": "ARC-1DEAE9E117B9"
      }
    ],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "Looking at the stars, not the same future",
        "recap": "Mei and Tim connected late in the retreat and went stargazing. They separated before the finale after clashing over his suggestion that she pursue Rob.",
        "partnerPersonIds": [
          "p-tim-malcolm"
        ],
        "relationshipId": "ARC-1DEAE9E117B9"
      }
    ]
  },
  "p-rocky-90-day-hunt-for-love-s1": {
    "connections": [
      {
        "name": "Chantel Everett",
        "personId": "p-chantel-everett",
        "context": "An earlier dating connection at the retreat."
      },
      {
        "name": "Tiffany Franco",
        "personId": "p-tiffany-franco",
        "context": "His later retreat partner, with a breakup confirmed at the tell-all.",
        "relationshipId": "ARC-64DAE29CF987"
      }
    ],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "From early dates to a late connection",
        "recap": "Rocky dated Chantel before a late match with Tiffany led them to leave together. Their tell-all update confirmed a breakup, with fitness remaining part of their contact.",
        "partnerPersonIds": [
          "p-chantel-everett",
          "p-tiffany-franco"
        ],
        "relationshipId": "ARC-64DAE29CF987"
      }
    ]
  },
  "p-jay-90-day-hunt-for-love-s1": {
    "connections": [
      {
        "name": "Tiffany Franco",
        "personId": "p-tiffany-franco",
        "context": "The returning cast member he dated at the retreat; no lasting partnership is claimed."
      }
    ],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "A date in a crowded courtship",
        "recap": "Jay dated Tiffany while she was also considering Carlo. Their conversation highlighted his humor and mutual interest, without establishing a lasting post-retreat relationship.",
        "partnerPersonIds": [
          "p-tiffany-franco"
        ]
      }
    ]
  },
  "p-joe-90-day-hunt-for-love-s1": {
    "connections": [
      {
        "name": "Chantel Everett",
        "personId": "p-chantel-everett",
        "context": "The returning participant he dated at the resort; an ongoing relationship is not claimed."
      }
    ],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "An unexpected date for Chantel",
        "recap": "Joe asked Chantel out, discussed their age difference and shared a beer-bath date with her. The footage establishes a retreat connection rather than a verified long-term couple.",
        "partnerPersonIds": [
          "p-chantel-everett"
        ]
      }
    ]
  },
  "p-nikki-90-day-hunt-for-love-s1": {
    "connections": [
      {
        "name": "Usman Umar",
        "personId": "p-usman-umar",
        "context": "Her featured retreat date, not a verified ongoing partner."
      }
    ],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "A date with different expectations",
        "recap": "Nikki and Usman shared an activity and hot-tub date, then found their expectations about partners did not match. Nikki supported getting to know other people rather than forcing the connection.",
        "partnerPersonIds": [
          "p-usman-umar"
        ]
      }
    ]
  },
  "p-kassidy-90-day-hunt-for-love-s1": {
    "connections": [
      {
        "name": "Usman Umar",
        "personId": "p-usman-umar",
        "context": "A documented retreat flirtation; no committed or ongoing partnership is claimed."
      }
    ],
    "seasons": [
      {
        "show": "90 Day: Hunt for Love",
        "season": 1,
        "title": "An introduction set to music",
        "recap": "Usman introduced himself to Kassidy through his music, and she asked him to improvise a song about her. This establishes a filmed interaction, not a verified relationship.",
        "partnerPersonIds": [
          "p-usman-umar"
        ]
      }
    ]
  }
}
